module.exports = __webpack_public_path__ + "media/components/assets/play-btn-043543fc9161804b195a30ec888e8093.svg";